import { LaptopIcon, MoonIcon, SunIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";
import { useTheme } from "@/providers/theme-provider";

export const ThemeSwitch = () => {
	const { theme, setTheme } = useTheme();

	return (
		<ButtonGroup>
			<Button
				className="h-8 w-1/3"
				onClick={() => setTheme("light")}
				variant={theme === "light" ? "secondary" : "ghost"}
			>
				<SunIcon className="size-4" />
			</Button>

			<Button
				className="h-8 w-1/3"
				onClick={() => setTheme("system")}
				variant={theme === "system" ? "secondary" : "ghost"}
			>
				<LaptopIcon className="size-4" />
			</Button>

			<Button className="h-8 w-1/3" onClick={() => setTheme("dark")} variant={theme === "dark" ? "secondary" : "ghost"}>
				<MoonIcon className="size-4" />
			</Button>
		</ButtonGroup>
	);
};
